/**
 * Knowledge Base Services
 */
export * from './KnowledgeBaseService';
export * from './KBCategoryService';
export * from './KBArticleService';
export * from './KBStepService';
export * from './KnowledgeBaseStatusService';
export * from './KBCategoryStatusService';
export * from './KBArticleStatusService';
export * from './KBStepTypeService';
export * from './KBVisibilityService';
export * from './KnowledgeBaseQAService';
export * from './PublicKnowledgeBaseService';
import { KnowledgeBaseService } from './KnowledgeBaseService';
import { KBCategoryService } from './KBCategoryService';
import { KBArticleService } from './KBArticleService';
import { KBStepService } from './KBStepService';
import { KnowledgeBaseStatusService } from './KnowledgeBaseStatusService';
import { KBCategoryStatusService } from './KBCategoryStatusService';
import { KBArticleStatusService } from './KBArticleStatusService';
import { KBStepTypeService } from './KBStepTypeService';
import { KBVisibilityService } from './KBVisibilityService';
import { KnowledgeBaseQAService } from './KnowledgeBaseQAService';
import { PublicKnowledgeBaseService } from './PublicKnowledgeBaseService';
/**
 * Create the Knowledge Base service container.
 *
 * The KB CRUD services share the Resource Management service path; the QA
 * service lives on AI Management. Pass <c>qaConfig</c> to override.
 */
export function createKnowledgeBaseServices(http, config, qaConfig) {
    return {
        knowledgeBase: new KnowledgeBaseService(http, config),
        category: new KBCategoryService(http, config),
        article: new KBArticleService(http, config),
        step: new KBStepService(http, config),
        status: new KnowledgeBaseStatusService(http, config),
        categoryStatus: new KBCategoryStatusService(http, config),
        articleStatus: new KBArticleStatusService(http, config),
        stepType: new KBStepTypeService(http, config),
        visibility: new KBVisibilityService(http, config),
        qa: new KnowledgeBaseQAService(http, qaConfig),
        public: new PublicKnowledgeBaseService(http, config),
    };
}
//# sourceMappingURL=index.js.map